var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.section ? "div" : "w-card",
    {
      tag: "component",
      staticClass: "vs-root",
      class: { "vs-section": _vm.section },
    },
    [
      _vm.section
        ? _c("div", { staticClass: "vs-section-head" }, [
            _vm._v(_vm._s(_vm.title)),
          ])
        : _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "div",
        { class: { "vs-content": !_vm.section } },
        [
          _vm.items
            ? _c(
                "w-sortable",
                {
                  attrs: {
                    items: _vm.items,
                    "disable-x": "",
                    "keep-in-y": "",
                    "target-class": "handle",
                  },
                  on: { drop: _vm.updateSettings },
                },
                _vm._l(_vm.items, function (item, i) {
                  return _c("div", { key: i, staticClass: "vs-row" }, [
                    _c(
                      "span",
                      { staticClass: "vs-grip handle" },
                      [_c("w-fa", { attrs: { icon: "grip-vertical" } })],
                      1
                    ),
                    _c(
                      "span",
                      { staticClass: "vs-row-icon" },
                      [
                        _c("w-fa", {
                          attrs: { icon: item.Icon || "external-link-alt" },
                        }),
                      ],
                      1
                    ),
                    _c("span", { staticClass: "vs-name" }, [
                      _vm._v(_vm._s(item.Name || _vm.$ct("missing-name"))),
                    ]),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-button"),
                            expression: "$ct('edit-button')",
                          },
                        ],
                        staticClass: "vs-ib",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.editClicked(item)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("delete-button"),
                            expression: "$ct('delete-button')",
                          },
                        ],
                        staticClass: "vs-ib del",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteButton(item)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
          _vm.items.length == 0
            ? _c("div", { staticClass: "vs-empty" }, [
                _vm._v(_vm._s(_vm.$ct("no-custom-buttons"))),
              ])
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "vs-add",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.createNew()
                },
              },
            },
            [
              _c("w-fa", { attrs: { icon: "plus" } }),
              _vm._v(_vm._s(_vm.$ct("extensions.add-button")) + " "),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.showCustomButtonEdit,
            callback: function ($$v) {
              _vm.showCustomButtonEdit = $$v
            },
            expression: "showCustomButtonEdit",
          },
        },
        [
          _c("app-custom-button-edit", {
            attrs: { value: _vm.editItem },
            on: {
              close: function ($event) {
                _vm.showCustomButtonEdit = false
              },
              save: function ($event) {
                return _vm.onSave()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }